import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  ChangeEvent,
} from 'react'
import {
  Cancelled,
  MembershipModel,
  PaginateModel,
  canceled,
  filterMembershipData,
  invoiceState,
  invoiced,
  paid,
} from './models'
import { startSxpProxy } from '../../utils/api'
import '../membership/membership.scss'
import {
  ADMIN_PROJECT_ID,
  MEMBERSHIP_PROJECT_ID,
  pageSizeOptions,
} from '../../utils/constants'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { selectSelectedLocationId } from '../location/locationSlice'
import { NavLink, useNavigate } from 'react-router-dom'
import MembershipSearch from './MembershipSearch'
import { MEMBERSHIP_UPDATE } from '../../utils/roles'
import KeycloakService from '../../utils/keycloakService'
import MaskedNumber from '../../components/MaskedNumber'
import { selectQuery, selectParam, setQueryParam } from './membershipSlice'
import { membership, noData } from '../Radiology/Constants/constants'
import { odooPharmacyLink } from '../appointments/models'
import ProvenanceView from '../../components/ProvenanceView'
import { create, update } from '../lms/constants'
import { ABMembershipIntent, Status } from '../AB Membership/constants'
import { unpaid } from '../OPDScreen/constant'
import { ColDef } from 'ag-grid-community'
import CustomHeader from '../Radiology/components/RadiologyModel/CustomHeader'
import { Box, Button, IconButton, Tooltip, useTheme } from '@mui/material'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import MedAgDataGrid from '../../components/MedAgDataGrid'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { stringToTitleCase } from './utils'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import EditNoteIcon from '@mui/icons-material/EditNote'

const styles = () => ({
  patientheading: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  deviceText: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  centerHeader: {
    color: '#ffffff',
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  editMembershipIcon: {
    height: '18px',
    width: '20px',
  },
  calendarMonthIcon: {
    color: '#625e5e !important',
    width: '22px',
    height: '20px',
  },
  unpaidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: '#E35335',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: '#E35335',
    },
  },
  paidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: 'green',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: 'green',
    },
  },
  endIcon: {
    fontSize: '13px !important',
  },
})
const Membership = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const query = useAppSelector(selectQuery)
  const param = useAppSelector(selectParam)
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1)
  const [limit, setLimit] = useState(100)

  const [paginate, setPaginate] = useState<PaginateModel>({
    totalCount: 0,
    totalPages: 0,
    data: [],
  })
  const [memberships, setMemberships] = useState<MembershipModel[]>([])
  const filteredMemberships = memberships.filter(
    (e) => e.partner?.ref !== false
  )
  const location = useAppSelector(selectSelectedLocationId)
  const handlePageChange = (newPage: any) => {
    setCurrentPage(newPage)
  }

  useEffect(() => {
    setCurrentPage(1)
  }, [limit, paginate.totalCount])
  const getMemberships = useCallback(
    (q: any, p: any) => {
      const state = {
        location,
        [q]: p,
        limit: limit,
        offset: (currentPage - 1) * limit,
        membershipType: filterMembershipData,
      }
      startSxpProxy(
        MEMBERSHIP_PROJECT_ID,
        ABMembershipIntent?.membershipLines,
        state
      )
        ?.then((data) => {
          setPaginate({
            totalCount: data?.data?.total_count,
            totalPages: data?.data?.total_pages,
            data: data?.data?.data,
          })
          const members: MembershipModel[] = data?.data?.data ?? []
          setMemberships(members)
        })
        .catch((err) => {
          console.log(err)
          setMemberships([])
          setPaginate({
            totalCount: 0,
            totalPages: 0,
            data: [],
          })
        })
        .finally(() => setLoading(false))
    },
    [location, currentPage, limit]
  )
  const index = (currentPage - 1) * limit
  const startIndex = index + 1
  const endIndex = Math.min(index + limit, paginate.totalCount)
  useEffect(() => {
    setLoading(true)
    getMemberships(query, param)
  }, [getMemberships, query, param])

  const membershipTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = membershipTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 60}px`
      }
    }
    window.addEventListener('resize', resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener('resize', resizeHandler)
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  const handleCreateMembership = () => {
    navigate('/membership/create')
  }
  console.log(filteredMemberships, 'memberships')
  const openOdooInvoice = (id: any) => {
    startSxpProxy(ADMIN_PROJECT_ID, odooPharmacyLink, {
      invoiceId: id,
      location: location,
    })
      .then((data) => {
        const url = data?.data?.auth_link
        window.open(url, '_blank', 'noopener,noreferrer')
      })
      .catch((err) => console.error(err, 'err'))
  }
  const onEdit = (id: any) => {
    navigate(`/membership-edit/${id}`)
  }
  const statusFunction = (id: string) => {
    switch (id) {
      case 'paid':
        return 'Paid Member'
      case 'none':
        return 'Non Member'
      case 'waiting':
        return 'Waiting Member'
      case 'invoiced':
        return 'Invoiced Member'
      case 'canceled':
        return 'Cancelled Member'
      case 'old':
        return 'Old Member'
      default:
        return 'Others'
    }
  }
  const dateCheck = (date: string) => {
    const d1 = new Date(date)
    const d2 = new Date()
    if (d1 >= d2) {
      return 'Active'
    } else {
      return 'Expired'
    }
  }
  const getStatusLabel = (state: any) => {
    const statusMap: any = {
      invoiced: unpaid,
      waiting: unpaid,
      paid: paid,
      old: paid,
    }
    return statusMap[state] || '-'
  }

  const handleSizeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setLimit(Number(e.target.value))
  }
  const handlePaymentClick = (params: any) => {
    const d = params?.data
    return invoiceState?.includes(d?.state) ? (
      <>
        {/* <span
        className={`status-badge ${
          getStatusColor(d?.state?.toLowerCase()) || ''
        }`}
        onClick={() => openOdooInvoice(d?.account_invoice_id?.id)}
      >
        {getStatusLabel(d?.state)}
      </span> */}
        <Button
          size='small'
          onClick={() => openOdooInvoice(d?.account_invoice_id?.id)}
          className={`${
            getStatusLabel(d?.state) === unpaid
              ? classes?.unpaidLink
              : classes?.paidLink
          }`}
          endIcon={
            getStatusLabel(d?.state) === unpaid ? (
              <OpenInNewIcon className={classes?.endIcon} />
            ) : (
              <CheckCircleOutlineIcon className={classes?.endIcon} />
            )
          }
        >
          {getStatusLabel(d?.state)}
        </Button>
      </>
    ) : (
      '-'
    )
  }
  const handleEditClick = (params: any) => {
    const d = params?.data
    return (
      <>
        <Tooltip title='Edit Membership'>
          <IconButton
            size='small'
            onClick={
              KeycloakService.hasRole([MEMBERSHIP_UPDATE])
                ? () => onEdit(d?.id)
                : undefined
            }
            disabled={!KeycloakService.hasRole([MEMBERSHIP_UPDATE])}
            className={`custom-btn custom-btn-primary ml10 ${
              KeycloakService.hasRole([MEMBERSHIP_UPDATE])
                ? 'cursor-pointer'
                : 'auth-disabled cursor-default'
            }`}
          >
            <EditNoteIcon
              fontSize='small'
              className={classes?.calendarMonthIcon}
            />
          </IconButton>
        </Tooltip>
      </>
    )
  }
  const columnDefs: ColDef[] = [
    {
      headerName: 'SL No',
      field: 'slNo',
      width: 80,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        (currentPage - 1) * limit + (params?.node?.rowIndex + 1),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Membership ID',
      field: 'membershipId',
      width: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => (
        <NavLink to={`/membership-dashboard/${params?.data?.id}`}>
          {params?.data?.name}
        </NavLink>
      ),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'UHID',
      field: 'name',
      minWidth: 140,
      sortable: false,
      filter: false,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) => params?.data?.partner?.ref ?? '-',
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Primary',
      field: 'primary',
      minWidth: 300,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.partner?.name ?? '-',
      headerComponent: CustomHeader,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
    },
    {
      headerName: 'Mobile',
      field: 'mobile',
      flex: 1,
      minWidth: 140,
      sortable: false,
      filter: true,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) =>
        params?.data?.partner?.phone ? (
          <MaskedNumber mobile={params?.data?.partner?.phone} />
        ) : (
          '-'
        ),
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Operating Unit',
      field: 'operatingUnit',
      flex: 1,
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        return (
          <>
            {params?.data?.account_invoice_id?.operating_unit_id?.[1]?.split(
              ' '
            )?.[1] ?? '-'}
          </>
        )
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Membership',
      field: 'membership',
      minWidth: 180,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) =>
        params?.data?.membership_id?.[1]
          ? stringToTitleCase(params?.data?.membership_id?.[1])
          : '-',
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
        display: 'flex',
      },
      wrapText: true,
    },
    {
      headerName: 'Mem.Type',
      field: 'name',
      minWidth: 165,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => statusFunction(params?.data?.state),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',

        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Validity',
      field: 'validity',
      flex: 1,
      minWidth: 100,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) =>
        params?.data?.date_to ? params?.data?.date_to : '-',
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
      },
      wrapText: true,
    },
    {
      headerName: 'Mem Status',
      field: 'status',
      minWidth: 75,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        const d = params?.data
        return d?.state === Status?.waiting || d?.state === invoiced
          ? Status?.waiting
          : d?.state === canceled
          ? Cancelled
          : d?.date_to
          ? dateCheck(d?.date_to)
          : noData
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
      },
    },
    {
      headerName: 'Pay.Status',
      field: 'validity',
      minWidth: 130,
      sortable: true,
      filter: true,
      cellRenderer: handlePaymentClick,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Action',
      field: 'edit',
      flex: 1,
      minWidth: 80,
      sortable: true,
      filter: true,
      cellRenderer: handleEditClick,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Created By',
      field: 'CreatedBy',
      minWidth: 150,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => (
        <ProvenanceView
          mode={create}
          date={params?.data?.account_invoice_id?.invoice_date_time ?? ''}
          name={params?.data?.account_invoice_id?.thop_user_name ?? ''}
        />
      ),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Updated By',
      field: 'UpdatedBy',
      minWidth: 150,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => (
        <ProvenanceView
          mode={update}
          date={params?.data?.write_date ?? ''}
          name={params?.data?.thop_last_updated_user_name ?? ''}
        />
      ),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
  ]

  return (
    <div className='layoutcontent total-width-content'>
      <div className='membership-dashboard-text'>{membership}</div>
      <Box height={'96%'} width={'100%'} marginTop={'-28px'}>
        <MedAgDataGrid
          tableHeight={'100%'}
          rowData={filteredMemberships}
          columnDefs={columnDefs}
          pagination={false}
          searchField={false}
          headerHeight={30}
          exportIcon={false}
          rowHeight={40}
          globalSearch={
            <MembershipSearch
              onCreate={handleCreateMembership}
              memberships={filteredMemberships}
            />
          }
          localSearch={false}
          enableCellTextSelection={true}
          loading={loading ? true : false}
        />
      </Box>
      <div className='text-right pagination-main-content'>
        <div className='inline-block membership-pagination text-right'>
          <select
            className='rowsperpage pagination-container'
            defaultValue={limit}
            onChange={handleSizeChange}
          >
            {pageSizeOptions?.map((size: number) => (
              <option key={size}>{size}</option>
            ))}
          </select>
          <span>
            <span className='mr10 pagination-container'>
              {startIndex}-{endIndex}/{paginate?.totalCount}{' '}
            </span>
          </span>
        </div>

        <div className='pagination-count-content'>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className={`icon-disable-btn ${
              currentPage !== 1 ? '' : 'disableBtn'
            }`}
            disabled={currentPage === 1}
          >
            <KeyboardArrowLeft />
          </button>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className={`icon-disable-btn ${
              currentPage !== paginate?.totalPages ? '' : 'disableBtn'
            }`}
            disabled={currentPage === paginate?.totalPages}
          >
            <KeyboardArrowRight />
          </button>
        </div>
      </div>
    </div>
  )
}

export default Membership
